import { bookFormatMap } from "../../../Utilities/mapUtil"
import { CoverRenderData } from "./types"

type PartialCoverPreview = Partial<CoverRenderData> & {
  region_background_url?: string | null
  album_direction?: string
}

type CoverPreviewSource = {
  format?: string | number
  coverPreviewData?: PartialCoverPreview
  cover_preview_data?: PartialCoverPreview
  coverPreview?: PartialCoverPreview
  album_direction?: string
}

const getAspectRatioByFormat = (format?: string | number): number => {
  if (format === undefined || format === null) return 1
  const formatSize = bookFormatMap.get(Number(format)) as string | undefined
  if (!formatSize) return 1
  const [width, height] = formatSize
    .split(/x/i)
    .map((value: string) => Number(value))
  if (!width || !height) return 1
  return width / height
}

export const buildCoverPreviewData = (
  item?: CoverPreviewSource | null,
  imageUrl?: string
): CoverRenderData | null => {
  const baseAspectRatio = getAspectRatioByFormat(item?.format)
  const providedCoverPreview =
    item?.coverPreviewData || item?.cover_preview_data || item?.coverPreview

  const fallbackImageElements =
    imageUrl && imageUrl.length > 0
      ? [
          {
            id: "cover-image",
            imageUrl,
            style: {
              left: "0%",
              top: "0%",
              width: "100%",
              height: "100%",
            },
          },
        ]
      : []

  if (providedCoverPreview) {
    return {
      aspectRatio: providedCoverPreview.aspectRatio || baseAspectRatio || 1,
      backgroundColor: providedCoverPreview.backgroundColor || "#ffffff",
      backgroundStyle: providedCoverPreview.backgroundStyle || {},
      regionBackgroundUrl:
        providedCoverPreview.regionBackgroundUrl ??
        providedCoverPreview.region_background_url ??
        null,
      albumDirection:
        providedCoverPreview.albumDirection ||
        providedCoverPreview.album_direction ||
        item?.album_direction ||
        "RTL",
      imageElements: Array.isArray(providedCoverPreview.imageElements) &&
        providedCoverPreview.imageElements.length > 0
          ? providedCoverPreview.imageElements
          : fallbackImageElements,
      textElements: providedCoverPreview.textElements || [],
    }
  }

  if (!fallbackImageElements.length) {
    return null
  }

  return {
    aspectRatio: baseAspectRatio || 1,
    backgroundColor: "#ffffff",
    backgroundStyle: {},
    regionBackgroundUrl: null,
    albumDirection: item?.album_direction || "RTL",
    imageElements: fallbackImageElements,
    textElements: [],
  }
}
